import styles from './Loader.module.css';

function Loader() {
    return (<div className={styles.container_spinner}>
        <div className={styles.spinner}/>
        <p>در حال بارگذاری...</p>
    </div>);
}

export default Loader;